module.exports = __webpack_public_path__ + "media/images/pages/icn_balloon_number_red_06-3731060aeaf345b3abe325321537f476.svg";